import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const getDefaultLine = () =>({

    product : null,
    reference :null,
    qty_ordered : null,
    qty_ordered_uvc : null,
    purchase_unit_price : null,
    purchase_description : '',
    margin:0,
    margin_price:null,
    total : 0,
    margin_rate : parseFloat(localStorage.PURCHASE_ORDER_MARGIN_VALUE),
    margin_type : 'PERCENT',
    custom_fields : [],
    price_tax_in : null,
    price : null,
    puid: null,
    productsInventory : [],
    genericPuid: null,
    productItem: null,
    _order : null,
    distinct: true,
    generic_puid: null,
})

const getDefaultState = () => ({
  products : [],
  loadingProducts : true,
  vendors : [],
  loadingVendors : true,
  purchaseOrder : {
    inventoryId : null,
    vendor : null,
    accountant : null,
    date : null,
    reception_planning_date : null,
    shipping_delay : null,
    reference : null,
    reference2 : null,
    adjustment : 0.00,
    notes : '',
    terms_conditions : '',
    lines : [],
    shipping_delay : null,
  },
  defaultLine : getDefaultLine(),
});



export default {
  namespaced: true,
  state: getDefaultState(),
  actions,
  getters,
  mutations,
  getDefaultState,
};
